import { useEffect } from 'react';
import { prepareLoginPublicMethod } from '../../generated/api/uiApiMethods';

export interface ElisaIdSessionCheckResultMessage {
  type: 'elisaIdSessionCheckResult';
  authenticated: boolean;
}

interface ElisaIdSessionCheckerProps {
  handleElisaIdSessionResult: (sessionValid: boolean) => void;
}

export const ELISA_ID_IFRAME_ID = 'elisa-id-session-checker-iframe';

const prepareLoginUrl = (): string => {
  const loginUrl = prepareLoginPublicMethod({
    callPath: decodeURIComponent(window.location.pathname),
    locale: 'fi',
    noPrompt: true,
  });
  return loginUrl.path;
};

export const ElisaIdSessionChecker = ({ handleElisaIdSessionResult }: ElisaIdSessionCheckerProps) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent<ElisaIdSessionCheckResultMessage>) => {
      if (event.origin !== window.location.origin) {
        console.warn('Received message from untrusted origin:', event.origin);
        return;
      }
      if (event.data?.type === 'elisaIdSessionCheckResult') {
        handleElisaIdSessionResult(event.data.authenticated);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleElisaIdSessionResult]);

  return (
    <iframe
      id={ELISA_ID_IFRAME_ID}
      src={prepareLoginUrl()}
      style={{ display: 'none' }}
      title="Elisa ID Session Checker"
      sandbox="allow-scripts allow-same-origin"
      aria-hidden="true"
    />
  );
};
